import styled from "styled-components";

import { flexColumn, rem } from "@styles/Utilities.styled";


export const StyledAddSlotTemplateModalContent = styled.div`
  ${flexColumn}
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  .form {
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;
    width: 100%;

    .form-field {
      margin-bottom: 1.5rem;
      width: 100%;
      max-width: 100%;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }

    .form-section {
      margin-bottom: 2rem;
      padding-bottom: 1.5rem;
      border-bottom: 1px solid var(--clr-gray-150);

      &:last-of-type {
        border-bottom: none;
      }

      .section-title {
        font-size: ${rem(16)};
        font-weight: 500;
        margin-bottom: 1rem;
        color: var(--clr-gray-700);
      }
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 1.5rem;
    margin-top: 1rem;
  }

  .checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
`;
